import { useField, useForm } from 'react-final-form'
import { useParams } from 'react-router-dom'
import { SelectFieldProps } from '../Select'
import { MembershipType } from '../../__generatedTypes__/globalTypes'
import { Select } from '../Select/Select'
import { PlatformSlug } from '../../constants/consts'
import { getMembershipLevelsConfig } from './platformConfig'

export type MembershipAccess = { id: MembershipType; title: string }

const FREE_MEMBERSHIP_ACCESS: MembershipAccess = {
  id: MembershipType.Free,
  title: 'Free Access',
}

const PREMIUM_MEMBERSHIP_ACCESS: MembershipAccess = {
  id: MembershipType.Premium,
  title: 'Premium Membership',
}

const PREMIUM_MAX_MEMBERSHIP_ACCESS: MembershipAccess = {
  id: MembershipType.PremiumMax,
  title: 'Premium Membership Max',
}

export const getMembershipAccessItems = (platform?: PlatformSlug) => {
  const config = getMembershipLevelsConfig(platform)
  const items = [FREE_MEMBERSHIP_ACCESS]

  if (config?.hasPremium) {
    items.push(PREMIUM_MEMBERSHIP_ACCESS)
  }

  if (config?.hasPremiumMax) {
    items.push(PREMIUM_MAX_MEMBERSHIP_ACCESS)
  }

  return items
}

export type MembershipLevelSelectProps = Pick<
  SelectFieldProps<MembershipType>,
  'name' | 'validate' | 'fullWidth' | 'className' | 'disabled'
> & {
  platform?: PlatformSlug
  hideWhenSingleOption?: boolean
}

export const MembershipLevelSelect = ({
  name,
  validate,
  platform: platformProp,
  hideWhenSingleOption = false,
  ...props
}: MembershipLevelSelectProps) => {
  const { platform: platformParam } = useParams()
  const platform = (platformProp ?? platformParam) as PlatformSlug
  const form = useForm()
  const { input, meta } = useField<MembershipType>(name, { validate })
  const membershipAccessItems = getMembershipAccessItems(platform)

  if (hideWhenSingleOption && membershipAccessItems.length === 1) {
    return null
  }

  const value = membershipAccessItems.find(({ id }) => id === input.value) ?? null

  return (
    <Select<MembershipAccess>
      {...input}
      value={value}
      onChange={(value) => form.change(name, value?.id ?? undefined)}
      error={Boolean(meta.touched && meta.error)}
      formHelperText={(meta.touched && meta.error) || undefined}
      items={membershipAccessItems}
      label="Membership Access"
      placeholder="Choose Membership Access"
      data-testid="membership-select"
      {...props}
    />
  )
}
